import { render } from "./ClientIntake.vue?vue&type=template&id=71e4b843&scoped=true"
import script from "./ClientIntake.vue?vue&type=script&lang=js"
export * from "./ClientIntake.vue?vue&type=script&lang=js"

import "./ClientIntake.vue?vue&type=style&index=0&id=71e4b843&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e4b843"]])

export default __exports__